export default "__VITE_ASSET__BmCnTd_Z__"